import { PageTitle } from '@/components/seo/page-title';
import { AdminDashboardScreen } from '@/features/admin/screens/admin-dashboard-screen';

export default function AdminDashboardRoute() {
  return (
    <>
      <PageTitle title="Admin" />
      <AdminDashboardScreen />
    </>
  );
}
